import React from "react";

export default function SmartSavings() {
  return <div>Smart Savings</div>;
}
